import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWikipedia = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 0H4C1.79086 0 0 1.79086 0 4V11C0 13.2091 1.79086 15 4 15H11C13.2091 15 15 13.2091 15 11V4C15 1.79086 13.2091 0 11 0Z",
			fill: "#118AB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7346 3.40918V3.62403C10.4641 3.67436 10.2593 3.7634 10.1203 3.89114C9.92122 4.08083 9.68642 4.37117 9.53242 4.76215L6.39852 11.4632H6.18992L3.04384 4.67505C2.89732 4.32665 2.69812 4.11374 2.63801 4.03631C2.54408 3.91631 2.42855 3.82243 2.29142 3.75468C2.15429 3.68694 1.96926 3.64339 1.73633 3.62403V3.40918H4.79759V3.62403C4.44443 3.65888 4.27606 3.72082 4.17087 3.80985C4.06567 3.89889 4.01307 4.01309 4.01307 4.15244C4.01307 4.34601 4.09948 4.64796 4.27231 5.0583L6.59572 9.67466L8.86742 5.11637C9.04392 4.66732 9.19042 4.35569 9.19052 4.18148C9.19042 4.06922 9.13602 3.9618 9.02702 3.8592C8.91812 3.75662 8.79482 3.68404 8.53552 3.64145C8.51682 3.63759 8.48482 3.63178 8.43972 3.62403V3.40918H10.7346Z",
			fill: "#DDEAF3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.43 3.40918V3.62403C13.1595 3.67436 12.9547 3.7634 12.8157 3.89114C12.6166 4.08083 12.3818 4.37117 12.2278 4.76215L9.47736 11.4632H9.26886L6.36246 4.67505C6.21586 4.32665 6.01676 4.11374 5.9566 4.03631C5.86267 3.91631 5.74715 3.82243 5.61002 3.75468C5.47288 3.68694 5.34866 3.64339 5.11572 3.62403V3.40918H8.11616V3.62403C7.76306 3.65888 7.59466 3.72082 7.48946 3.80985C7.38426 3.89889 7.33166 4.01309 7.33166 4.15244C7.33166 4.34601 7.41806 4.64796 7.59086 5.0583L9.67466 9.67466L11.5628 5.11637C11.7394 4.66732 11.8859 4.35569 11.8859 4.18148C11.8859 4.06922 11.8314 3.9618 11.7224 3.8592C11.6135 3.75662 11.4294 3.68404 11.1702 3.64145C11.1514 3.63759 11.1194 3.63178 11.0744 3.62403V3.40918H13.43Z",
			fill: "#DDEAF3"
		})
	]
});
export default SvgWikipedia;
